"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.open = void 0;
var open = function open(_ref) {
  var href = _ref.href,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target;
  var a = document.createElement('a');
  a.href = href;
  a.target = target;
  a.click();
  a.remove();
};
exports.open = open;